module.exports = "<p>\n  no-access works!\n</p>"